module.exports = __webpack_public_path__ + "img/gruplarg.65522734.jpg";